import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Leaderboard from "./pages/Leaderboard";
import GameWrapper from "./pages/GameWrapper";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/game/:gameType" element={<GameWrapper />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
